import { createSlice } from "@reduxjs/toolkit";

const translatorSlice = createSlice({
  name: "translator",
  initialState: {
    translatorDetails: [],
    assignedFolders: [],
    assignedFiles: [],
    selectedAssignedProjectId: null,
    selectedAssignedFolderId: null,
    selectedAssignedFileId: null,
    selectedFile: {},
    fileStatus: null,
  },
  reducers: {
    addTranslatorDetails: (state, action) => {
      state.validatorDetails = action.payload;
    },
    addAssignedFolders: (state, action) => {
      state.assignedFolders = {
        ...state.assignedFolders,
        [state.selectedAssignedProjectId]: action.payload,
      };
    },
    addAssignedFiles: (state, action) => {
      state.assignedFiles = {
        ...state.assignedFiles,
        [state.selectedAssignedFolderId]: action.payload,
      };
    },
    setSelectedAssignedProjectId: (state, action) => {
      state.selectedAssignedProjectId = action.payload;
    },
    setSelectedAssignedFolderId: (state, action) => {
      state.selectedAssignedFolderId = action.payload;
    },
    setSelectedAssignedFileId: (state, action) => {
      state.selectedAssignedFileId = action.payload;
    },
    setSelectedFile: (state, action) => {
      state.selectedFile = action.payload;
    },
    setSelectedFileStatus: (state, action) => {
      state.fileStatus = action.payload;
    },
  },
});

export const {
  addValidatorDetails,
  addAssignedFolders,
  addAssignedFiles,
  setSelectedAssignedProjectId,
  setSelectedAssignedFolderId,
  setSelectedAssignedFileId,
  setSelectedFile,
  setSelectedFileStatus
} = translatorSlice.actions;

export default translatorSlice.reducer;
